module.exports = __webpack_public_path__ + "6c7a76814a2c110d5f0cfda5e38dbedc.png";